<template>
    <div class="app-view-template-secondary">
      <app-banner-small :title="title" :brands="brands" :text="text"></app-banner-small>

      <app-content-default-template v-if="!contentFullPage">
        <slot/>
      </app-content-default-template>

      <div class="full-page-content" v-if="contentFullPage">
          <slot/>
      </div>

      <subscription-widget/>
    </div>
</template>

<script>
  import AppContentDefaultTemplate from '@/components/layout/templates/content/AppContentTemplateDefault';
  import AppBannerSmall from '@/components/layout/banners/AppBannerSmall';
  import SubscriptionWidget from "@/components/widgets/subscription/Subscription";

  export default {
    name: 'AppViewTemplateSecondary',

    props: {
      title: String,
      text: String,
      brands: {
          type: Object,
      },
      contentFullPage: {
          default: false,
      }
    },

    components: {
      SubscriptionWidget,
      AppContentDefaultTemplate, AppBannerSmall,
    }
  }
</script>

<style lang="scss">
  .app-view-template-secondary {
    width: 100%;

      .buttons-wrapper button {
          &:first-child {
              margin-right: 0;
          }
      }

      @media (min-width: $mdBreakpoint) {
          .buttons-wrapper button {
              &:first-child {
                  margin-right: 30px;
              }
          }
      }
  }
</style>
